import { render, staticRenderFns } from "./PromoExceptions.vue?vue&type=template&id=21a6c626&scoped=true&"
import script from "./PromoExceptions.vue?vue&type=script&lang=js&"
export * from "./PromoExceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6c626",
  null
  
)

export default component.exports